import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom"; // useLocation을 추가로 import합니다.
import LocationCard from "components/card/LocationCard";
import Navigation from "components/Navigation";
import TabHeader from "components/common/TabHeader";
import SubHeader from "components/common/SubHeader";
import NoData from "components/common/NoData";
// import { getDivingPools } from "api/class";
import locationImg from "assets/images/imgs/banner/all_location.jpg";

const categories = ["전체", "수영장", "잠수풀", "개방수역"];

function LocationPage() {
    const navigate = useNavigate();
    const locState = useLocation(); //MainPage에서 스포츠 카테고리 넘겨줌
    const { selectedSport } = locState.state || {};

    // 카테고리 / 복사된 ID / 모달 제어
    const [selectedCategory, setSelectedCategory] = useState("전체");
    const [divingPools, setDivingPools] = useState([]);

    // 카테고리 필터링
    const filteredLocations =
        selectedCategory === "전체"
            ? divingPools
            : divingPools.filter((loc) => loc.category === selectedCategory);

    useEffect(() => {
    }, [selectedSport]);

    // 모달 내 "이 장소 예약하기" → sports-learning 페이지로 이동
    const handleLocationSelect = (loc) => {
        navigate("/class-reservation", {
            state: {
                location: loc.name,
                selectedSport,
            },
        });
    };

    return (
        <div className="location-page">
            <Navigation />
            <SubHeader title={selectedSport} />
            <TabHeader
                marginTop={107}
                menus={categories}
                defaultTab={selectedCategory}
                setSelectedTab={setSelectedCategory}
            />
            <div className="location-wrap">
                <div
                    className="all-location-wrap"
                    onClick={() =>
                        navigate("/class-reservation", {
                            state: {
                                location: "전체",
                                selectedSport,
                            },
                        })
                    }
                >
                    <img src={locationImg} alt="" />
                </div>

                {filteredLocations.length > 0 ? (
                    <>
                        {filteredLocations.map((loc, index) => (
                            <LocationCard
                                key={`location-${index}`}
                                loc={loc}
                                selectedSport={selectedSport}
                                onClickFunc={handleLocationSelect}
                            />
                        ))}
                    </>
                ) : (
                    <NoData
                        title="🫥"
                        desc="추가 장소 개설은 카카오 채널로 문의해주세요."
                    />
                )}
            </div>
        </div>
    );
}

export default LocationPage;
